module.exports = __webpack_public_path__ + "img/AM_Poster_AugsburgOpen_201780684_3.e2d25f5c.png";